var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96.52 96.52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.16,51.28,48.61,5.8a19.73,19.73,0,0,0-6.5-4.11A19.68,19.68,0,0,0,34.66,0H8.15A7.84,7.84,0,0,0,2.42,2.42,7.84,7.84,0,0,0,0,8.15v26.5a19.67,19.67,0,0,0,1.69,7.45A19,19,0,0,0,5.8,48.54L51.35,94.16a7.8,7.8,0,0,0,5.73,2.36,8.16,8.16,0,0,0,5.8-2.36L94.16,62.82a7.8,7.8,0,0,0,2.36-5.73A8.16,8.16,0,0,0,94.16,51.28ZM20.39,28.54a8.16,8.16,0,0,1-8.15-8.15,8.16,8.16,0,0,1,8.15-8.15,8.16,8.16,0,0,1,8.15,8.15,8.16,8.16,0,0,1-8.15,8.15ZM50.68,62.95a4.63,4.63,0,0,1-6.54,0l-16.2-16.2a4.63,4.63,0,1,1,6.54-6.54l16.2,16.2A4.62,4.62,0,0,1,50.68,62.95Zm24-2.27a4.62,4.62,0,0,1-6.54,0l-27-27a4.63,4.63,0,0,1,6.54-6.54l27,27A4.62,4.62,0,0,1,74.65,60.67Z",
    fill: "#000957"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.29e6c944d959bb2e527a11db5648c5ae.svg";
export { ForwardRef as ReactComponent };